import React from 'react';
import { Check } from 'lucide-react';

export const WhyChooseUs = ({ reasons }) => {
  return (
    <section className="bg-[#FFF6F2] py-20 px-6 sm:px-12 lg:px-48 text-gray-800">
      {/* === Header === */}
      <div className="max-w-3xl  text-start mb-12">
        <h2 className="text-2xl sm:text-5xl font-bold mb-4 text-[#F8AF10] just-me-again-down-here-regular">
          {reasons?.label}
        </h2>
        <p className="text-sm sm:text-base text-gray-700">{reasons?.caption}</p>
      </div>

      {/* === Points === */}
      <div className="max-w-2xl space-y-5 text-left">
        {reasons?.items?.map((item, index) => (
          <div key={index} className="flex items-start space-x-3">
            <Check className="w-5 h-5 text-[#AC3F1E] flex-shrink-0 mt-1" />
            <p className="text-sm sm:text-base text-gray-800">{item}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
